module.exports = function(app){
    app.directive('clickableStars', function () {

        return{
            restrict : 'A',
            replace : false,
            scope : {
                clickableStars : '='
            },
            template :  '<span data-ng-click="clickableStars = 1" aria-label="1 star" role="button" data-ng-keypress="clickableStars = 1" class="outerStar" tabindex="0" style="position: relative;">' +
                            '<span class="hm-icon colored icon-full-star-yellow" data-ng-show="clickableStars >= 1"></span>' +
                            '<span class="hm-icon colored icon-full-star-white" data-ng-show="clickableStars < 1"></span>' +
                            '<span class="hm-icon icon-black-star-outline"></span>' +
                        '</span>'+
                        '<span data-ng-click="clickableStars = 2" aria-label="2 stars" role="button" data-ng-keypress="clickableStars = 2" class="outerStar" tabindex="0" style="position: relative;">' +
                            '<span class="hm-icon colored icon-full-star-yellow" data-ng-show="clickableStars >= 2"></span>' +
                            '<span class="hm-icon colored icon-full-star-white" data-ng-show="clickableStars < 2"></span>' +
                            '<span class="hm-icon icon-black-star-outline"></span>' +
                        '</span>'+
                        '<span data-ng-click="clickableStars = 3" aria-label="3 stars" role="button" data-ng-keypress="clickableStars = 3" class="outerStar" tabindex="0" style="position: relative;">' +
                            '<span class="hm-icon colored icon-full-star-yellow" data-ng-show="clickableStars >= 3"></span>' +
                            '<span class="hm-icon colored icon-full-star-white" data-ng-show="clickableStars < 3"></span>' +
                            '<span class="hm-icon icon-black-star-outline"></span>' +
                        '</span>' +
                        '<span data-ng-click="clickableStars = 4" aria-label="4 stars" role="button" data-ng-keypress="clickableStars = 4" class="outerStar" tabindex="0" style="position: relative;">' +
                            '<span class="hm-icon colored icon-full-star-yellow" data-ng-show="clickableStars >= 4"></span>' +
                            '<span class="hm-icon colored icon-full-star-white" data-ng-show="clickableStars < 4"></span>' +
                            '<span class="hm-icon icon-black-star-outline"></span>' +
                        '</span>' +
                        '<span data-ng-click="clickableStars = 5" aria-label="5 stars" role="button" data-ng-keypress="clickableStars = 5" class="outerStar" tabindex="0" style="position: relative;">' +
                            '<span class="hm-icon colored icon-full-star-yellow" data-ng-show="clickableStars >= 5"></span>' +
                            '<span class="hm-icon colored icon-full-star-white" data-ng-show="clickableStars < 5"></span>' +
                            '<span class="hm-icon icon-black-star-outline"></span>' +
                        '</span>',
            controller : ['$scope', function ($scope) {
                $scope.clickableStars = 0;
            }]
        };
    });
};